import { criteria } from "../Models/criteria";
import { schedule } from "../Models/schedule";

export const defaultCriteria: criteria = {
    id: ".",
    criterias: {
        departmentIds: [],
        productGroupIds: [],
        seasonIds: [],
    },
    trigger: "BelowMin",
    action: "OrderToMax"
}

export const defaultSchedule: schedule = {
    id: ".",
    name: "",
    runTime: "06:00",
    autoApprovalTime: "10:00",
    destinationLocations: [],
    days: [],
    frequency: "Daily",
    sourceLocationId: undefined,
    criteriaId: "",
    isActive: true,
    timeZone: ""
}